import config from '../config';
// export const BASE_URL = `${config.apiGateway.URL}:${config.apiGateway.PORT}`;
// temp solution for demo environment
export const MAIN_URI = window.location.hostname
export const MAIN_PROTOCOL = window.location.protocol
export const BASE_PORT = config.apiGateway.PORT
export const API_V = '/api/v1';

export const AUTOMMATE_API_URL = `${config.apiGateway.AUTOMMATE_API_HOST}:${config.apiGateway.AUTOMMATE_API_PORT}${API_V}`;

function GET_BASE_URL() {
    const data = window.cFileData;
    console.log("DATA", data)
    console.log("BASE_PORT", BASE_PORT)
    console.log("Read Service Port:", data);
    try {
        if (data.apiGateway.PORT) {
            return `${MAIN_PROTOCOL}//${MAIN_URI}:${data.apiGateway.PORT}${API_V}`;
        } else {
            console.log('url' + `${MAIN_PROTOCOL}//${MAIN_URI}:${BASE_PORT}${API_V}`)
            return `${MAIN_PROTOCOL}//${MAIN_URI}:${BASE_PORT}${API_V}`;
        }
    } catch (err) {
        console.log("error:=>", err);
        return `${MAIN_PROTOCOL}//${MAIN_URI}:${BASE_PORT}${API_V}`;
    }

}

export const BASE_URL = GET_BASE_URL();

export const ADMIN = {
    ID: '9bf95756-269c-478e-8421-8834f19dc359',
    ROLE_NAME: 'Admin',
    ROLE_ID: '63240945-f9a7-497f-a132-c0c3b7aa32c7'
};
export const GUEST = {
    ID: 'c169ef5c-3975-499c-ba5b-918c5e845b3c',
    ROLE_NAME: 'User',
    ROLE_ID: 'b99d100a-38fb-459d-aec7-29920da62562'
};
export const AUTOM_MAKER = {
    ROLE_NAME: 'Autom Maker',
    ROLE_ID: 'd9c3d601-6fb6-417e-bf8b-d5aff8922474'
};
export const IPAAS_DEV = {
    ID: 'c169ef5c-3975-499c-ba5b-918c5e845b66',
    ROLE_NAME: 'IPAAS Developer',
    ROLE_ID: '9bf95756-269c-478e-8421-8834f19dc3ta'
};
export const RPA_DEV = {
    ID: 'c169ef5c-3975-499c-ba5b-918c5e845b77',
    ROLE_NAME: 'RPA Developer',
    ROLE_ID: '9bf95756-269c-478e-8421-8834f19dc3c6'
};
export const DEPENDENT_PERMISSION = 'CONTENT.MODULE.PERMISSION.VIEW';
export const NETWORK_ERROR = {message: 'GENERAL.NETWORK-ERROR', status: false};
